import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Component, OnDestroy, OnInit, viewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { TranslateService } from '@ngx-translate/core';
import { finalize, tap } from 'rxjs/operators';

import { SendTypes, UseTypes } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AuthTokenService } from 'src/app/core/services/authentication/auth-token.service';
import { AppConfigService } from 'src/app/core/services/config.service';
import { ConsoleService } from 'src/app/core/services/console.service';
import { FileService } from 'src/app/core/services/file.service';
import { CreateP2PScheduledMessageCommand } from '../../../core/api/models/create-p-2-p-scheduled-message-command';
import { GetScheduledMessageByIdDto } from '../../../core/api/models/get-scheduled-message-by-id-dto';
import { PrivateNumbersService } from '../../../core/api/services/private-numbers.service';
import { ScheduledMessagesService } from '../../../core/api/services/scheduled-messages.service';
import { FormPageConfig } from '../../../core/models/form-page-config.model';
import { DialogService } from '../../../core/services/dialog.service';
import { DynamicTabService } from '../../../core/services/dynamic-tab.service';
import { UtilityService } from '../../../core/services/utility.service';
import { BaseFormPageComponent } from '../../shared/base/components/base-form-page.component';
import { TabsDynamicComponent } from './../../../layout/components/tabs-dynamic/tabs-dynamic.component';
import { DateTimeConfig } from './../../../shared/components/date-time-picker/date-time-picker.component';

@Component({
    selector: 'app-send-p2p-sms',
    templateUrl: './send-p2p-sms.component.html',
    styleUrls: ['../base/base-sending-system.component.scss'],
    standalone: false
})
export class SendP2pSmsComponent
  extends BaseFormPageComponent
  implements OnInit, OnDestroy
{
  //#region properties
  tabName: string = 'sendP2pSms';

  jsonData: Array<Object> = null;
  importedColList: string[] = [];
  previewModel: any[] = [];

  totalEntry = 0;

  readonly stepper = viewChild<MatStepper>('stepper');

  title: string = '';
  model: CreateP2PScheduledMessageCommand = {};
  formPageConfig: FormPageConfig<GetScheduledMessageByIdDto> = {};

  directDateTimeConfig: DateTimeConfig;
  isVisibleHelpPage: boolean = false;

  smsBodyGenerator: FormGroup;
  filePath: string = '';
  progress: number;
  finalImportedColList: { value: string }[];
  get SendTypes() {
    return SendTypes;
  }
  get UseTypes() {
    return UseTypes;
  }

  sendLoading: boolean;
  action: string =
    AppConfigService.config.apiUrl + '/ScheduledMessages/UploadFile';
  apiUrl: string = AppConfigService.config.apiUrl;
  isCanSendFlashSms: boolean = false;

  //#endregion

  constructor(
    protected currentService: ScheduledMessagesService,
    protected dialogService: DialogService,
    protected utilityService: UtilityService,
    protected translate: TranslateService,
    protected dynamicTabService: DynamicTabService,
    protected privateNumberService: PrivateNumbersService,
    protected fileService: FileService,
    protected http: HttpClient,
    protected tabsDynamicComponent: TabsDynamicComponent
  ) {
    super();
  }

  ngOnInit() {
    try {
      this.baseCreateGetApiForSend(
        this.currentService,
        'scheduledMessagesCreateP2PScheduledMessageGet'
      );
      super.ngOnInit();
      this.pageVocabs = 'pages.sendP2pSms.';
      this.configDirectDateTimeComponent();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  closeThisTab() {
    try {
      const TimeOut = setTimeout(() => {
        this.tabsDynamicComponent.manualCloseTab('sendP2pSms');
        clearTimeout(TimeOut);
      }, 50);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  ngAfterViewInit(): void {
    // this.moveToStep2();
  }

  initModel() {}

  configDirectDateTimeComponent() {
    try {
      this.directDateTimeConfig = {
        dateLabel: 'common.sendDay',
        timeLabel: 'common.sendHour',
        dateFormControl: this.form?.get('sendDate') as FormControl,
        timeFormControl: this.form?.get('sendTime') as FormControl,
        isDefaultValue: true,
        minDateType: 'today',
        responsiveClassName: 'md:tw-w-1/2',
        isEditMode: this.formPageConfig.isEditMode,
      };
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  initForm() {
    this.form = new FormGroup({
      senderNumberId: new FormControl('', Validators.required),
      inputFile: new FormControl('', Validators.required),
      sendDate: new FormControl('', Validators.required),
      sendTime: new FormControl('', Validators.required),
      description: new FormControl(''),
      isSendDuplicateNumber: new FormControl(),
      isFlashSms: new FormControl(),
    });
  }

  //#region Api

  //create
  baseCreateApi(model: CreateP2PScheduledMessageCommand) {
    this.unSubs();
    this.sendLoading = true;
    this.loading = true;
    // this.model.pattern = this.model.pattern.toUpperCase();

    this.model.pattern = this.model.pattern.replace(/\[(.*?)\]/g, (item) =>
      item.toUpperCase()
    );

    this.currentService
      .scheduledMessagesCreateP2PScheduledMessagePost({ body: model })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.sendLoading = false))
      )
      .subscribe((result) => {
        try {
          this.apiNotificationService.notifyMessage({
            result,
            mode: 'matDialog',
          });
          if (result.isSucceed) {
            this.onSuccess();
            this.refreshPage();
          }
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.sendingSystem
          );
        }
      });
  }

  //#endregion

  readFile(file: File) {
    try {
      this.previewModel = null;
      this.importedColList = [];

      this.loading = true;

      if (file == null || file == undefined) {
        this.jsonData = null;
        this.loading = false;
        this.totalEntry = 0;
        this.importedColList = [];
        return;
      }

      this.progress = 1;
      let formData: any = new FormData();
      let fileToUpload = <File>file;

      formData.append(
        'file',
        fileToUpload,
        fileToUpload.name.replace(/\s/g, '')
      );
      formData.append('sendTypes', SendTypes.P2P);

      const headers = new HttpHeaders()
        .set('Accept', 'application/json')
        .set('enctype', 'multipart/form-data')
        .set('ngsw-bypass', 'true')
        .set('Authorization', 'Bearer ' + AuthTokenService.getAccessToken());

      this.http
        .post(this.action, formData, {
          headers: headers,
          reportProgress: true,
          observe: 'events',
        })
        .pipe(
          this.basePipeOperators(),
          tap((event: any) => {
            if (event.type == HttpEventType.UploadProgress) {
              ConsoleService.info('loaded', event.loaded);
              ConsoleService.info('loaded', event.total);
              this.progress = Math.round((100 / event.total) * event.loaded);
            } else if (event.type == HttpEventType.Response) {
              this.progress = null;
            }
          })
        )
        .subscribe((result) => {
          if (result.body) {
            result = result.body;
            this.apiNotificationService.notifyMessage({ result });
            if (result.isSucceed) {
              let data = JSON.parse(result?.data);
              this.filePath = data.path;

              this.importedColList = [];
              this.jsonData = null;
              this.model.pattern = '';
              this.totalEntry = 0;
              this.loading = false;

              if (this.fileService.isValidColumnNames(data.data[0])) {
                this.importedColList = data.data[0];
                this.finalImportedColList = this.importedColList?.map(
                  (str) => ({
                    value: str,
                  })
                );
                this.jsonData = data.data;
                this.totalEntry = this.jsonData.length;
                this.getPreviewModel();
              }
            }
          }
        });

      // this.currentService
      //   .scheduledMessagesUploadFile({ body: { File: file } })
      //   .pipe(this.basePipeOperators(),
      //     finalize(() => (this.loading = false)))
      //   .subscribe((result) => {
      //     this.progress = Math.round((100 / result.total) * result.loaded)

      //     this.apiNotificationService.notifyMessage({ result });
      //     if (result.isSucceed) {
      //       let data = JSON.parse(result.detail)
      //       this.filePath = data.Path;

      //       this.importedColList = [];
      //       this.jsonData = null;
      //       this.model.pattern = "";
      //       this.totalEntry = 0;
      //       this.loading = false;

      //       //set Titles instead of data.Data[0] after backend update
      //       if (this.fileService.isValidColumnNames(data.Data[0])) {
      //         this.importedColList = data.Data[0];
      //         this.jsonData = data.Data;
      //         this.totalEntry = this.jsonData.length;
      //         this.getPreviewModel();
      //       }
      //     }
      //   });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }
  getPreviewModel() {
    try {
      this.previewModel = [];
      // let itemsLength = 6;
      // if (this.jsonData.length < 6)
      //   itemsLength = this.jsonData.length;
      // this.previewModel = Object.values(this.jsonData);
      for (let index = 1; index < this.jsonData.length; index++) {
        this.previewModel.push(Object.values(this.jsonData[index]));
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  moveToStep2() {
    try {
      this.stepper().next();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  openPage(tabName: string) {
    try {
      this.dynamicTabService.setNewTab('');
      this.dynamicTabService.setNewTab(tabName);
      this.dynamicTabService.setActiveTab(tabName);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (!this.isValidForm(this.smsBodyGenerator, 'P2pSmsBodyGeneratorForm'))
        return;
      if (
        this.importedColList.length === 0 ||
        !this.model.pattern ||
        !this.model.toNumberFieldName
      ) {
        return;
      }

      if (!this.form.valid || this.loading || this.jsonData == null) return;

      // set recipients
      let data = JSON.stringify(this.jsonData);

      // this.model.recipients = this.compressionString(data);
      this.model.path = this.apiUrl + '/' + this.filePath;

      //call api method
      this.baseCreateApi(this.model);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  unSubs() {
    try {
      this.onDestroy$.next();
      this.onDestroy$.complete();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }
  onShowHelpPage() {
    this.isVisibleHelpPage = true;
  }
  onHideHelpPage() {
    this.isVisibleHelpPage = false;
  }

  refreshPage() {
    this.tabsDynamicComponent.refreshTab(this.tabName);
  }
}
